module.exports = __webpack_public_path__ + "static/media/pt.09cd4ef9.svg";